import styled from 'styled-components';

export const Wrapper = styled.div``;

export const ModalWrapper = styled.div`
	background-color: ${({ theme }) => theme.colors.background.secondary};
	border-radius: 12px;
	max-width: 612px;
	width: 100%;
	margin: 0 auto;
`;

export const Header = styled.div`
	display: grid;
	grid-template-columns: auto 1fr;
	align-items: center;
	border-bottom: 1px solid ${({ theme }) => theme.colors.transparent.light15};
	border-radius: 12px 12px 0 0;
	padding: 16px;
`;

export const Title = styled.div`
	font-size: 24px;
	color: ${({ theme }) => theme.colors.text.title};
	text-align: center;
	font-weight: 600;
`;

export const Content = styled.div`
	padding: 16px;
`;

export const Info = styled.div`
	text-align: center;
	font-size: 16px;
	color: ${({ theme }) => theme.colors.text.body};
`;

export const InputWrapper = styled.div`
	margin-top: 16px;
`;

export const ButtonsGroup = styled.div`
	display: flex;
	align-items: center;
	gap: 16px;
`;

export const PreFooter = styled.div`
	display: flex;
	justify-content: space-between;
	margin-top: 16px;
`;

export const Footer = styled.div`
	font-size: 14px;
	font-weight: 400;
	text-align: center;
	color: ${({ theme }) => theme.colors.text.body};
	margin-top: 24px;
`;
